var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({ maxWidth: `${_vm.size}px` }),attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"44","stroke":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }